<template>



    <div class="view-revenue">
        <div v-if="loadingRevenue && stripeReady" style="margin-top:10px" class="text-center">
            <v-skeleton-loader type="table"></v-skeleton-loader>
        </div>

        <!-- Empty state - no financial data -->
        <div v-else-if="!loadingRevenue && !revenueFiltered" class="d-flex align-center justify-center"
            style="min-height: 70vh;">
            <v-row class="d-flex align-center justify-center">
                <v-col class="d-flex flex-column align-center justify-center" cols="12">
                    <v-img class="mb-6" height="130" :src="require('@/assets/icons/admin+/financial_revenue.svg')"
                        contain></v-img>
                    <div class="text-center mb-6">
                        <span class="font-roboto text-empty">
                            No revenue yet.
                        </span>
                        <div class="text-body-1 text-empty">
                            Revenue will appear here once you start selling memberships or products.
                        </div>
                    </div>
                    <v-btn small outlined class="plusIndigoDarken1" @click="navigateTo({ name: 'products' })">
                        <span class="font-roboto text-button d-inline plusSurface--text">Go to Products &
                            Memberships</span>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div v-else>
            <v-container fluid>

                <!-- summary cards -->
                <div
                    class="d-inline-flex flex-wrap mb-4 rounded-lg mobile-header-financial justify-space-between align-center pa-lg-2 pa-5">
                    <v-col cols="12" lg="auto">
                        <div class="d-flex flex-row  align-center align-lg-center text-left item_header pb-4">
                            <div class="rounded-lg pa-3 mb-2 mr-2 plusLightGreenLighten5">
                                <v-img :src="require('@/assets/icons/admin+/atm_local.svg')" width="36"
                                    height="36"></v-img>
                            </div>
                            <div>
                                <div class="font-roboto text-h5">
                                    <v-progress-circular size="36" v-if="loadingRevenue" :width="2"
                                        indeterminate></v-progress-circular>
                                    <span v-else>{{ currencySymbol }}{{ monthlyTotalRevenue }}</span>
                                </div>
                                <div class="text-body-2 font-roboto">Monthly Total Revenue</div>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" lg="auto">
                        <div class="d-flex flex-row  align-center align-lg-center text-left item_header pb-4">
                            <div class="rounded-lg pa-3 mb-2  mr-2 plusTealLighten5">
                                <v-img :src="require('@/assets/icons/admin+/currency-exchange.svg')" width="36"
                                    height="36"></v-img>
                            </div>
                            <div>
                                <div class="font-roboto text-h5">
                                    <v-progress-circular size="20" v-if="loadingRevenue" :width="2"
                                        indeterminate></v-progress-circular>
                                    <span v-else>{{ currencySymbol }}{{ monthlyRecurringRevenue }}</span>
                                </div>
                                <div class="text-body-2 font-roboto">
                                    Monthly recurring revenue</div>
                            </div>
                        </div>

                    </v-col>

                    <v-col cols="12" lg="auto">
                        <div class="d-flex flex-row align-center align-lg-center text-left item_header pb-4">
                            <div class="rounded-lg pa-3 mb-2 mr-2 plusAmberLighten5">
                                <v-icon size="36" color="plusAmberDarken4">mdi-clock-time-eight-outline</v-icon>
                            </div>
                            <div>
                                <div class="font-roboto text-h5">
                                    <v-progress-circular size="20" v-if="loadingRevenue" :width="2"
                                        indeterminate></v-progress-circular>
                                    <span v-else>{{ oneTimeRevenueCount }}</span>
                                </div>
                                <div class="text-body-2 font-roboto">One-Time Revenue</div>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" lg="auto">
                        <div class="d-flex flex-row align-center align-lg-center text-left item_header pb-4">
                            <div class="rounded-lg pa-3 mb-2 mr-2 plusDeepOrangeLighten5">
                                <v-icon size="36" color="plusDeepOrangeAccent4">mdi-block-helper</v-icon>
                            </div>
                            <div>
                                <div class="font-roboto text-h5">
                                    <v-progress-circular size="20" v-if="loadingRevenue" :width="2"
                                        indeterminate></v-progress-circular>
                                    <span v-else>{{ pendingPaymentsCount }}</span>
                                </div>
                                <div class="text-body-2 font-roboto">Pending payments</div>
                            </div>
                        </div>
                    </v-col>
                </div>

                <!-- Type filter -->

                <v-card elevation="0" class="mb-lg-3 mt-1 pa-6 rounded-lg border-filter-revenue">
                    <v-card-text class="pa-0 mb-1">
                        <v-row>
                            <v-col class="pb-0" cols="12" lg="2">
                                <v-text-field :hide-details="true" dense outlined label="Search by member"
                                    background-color="plusTextOnSecondary" prepend-inner-icon="mdi-magnify"
                                    @keyup="$emit('filter-revenue')" :value="revenueUserFilter"
                                    @input="$emit('update:revenue-user-filter', $event)">
                                </v-text-field>
                            </v-col>
                            <!-- type -->
                            <v-col class="pb-0  d-lg-flex" cols="12" lg="2"
                                :class="displayFilters ? '' : 'd-lg-flex d-none'">

                                <v-select v-if="revenueTypeFilters" :items="revenueTypeFilters" item-text="text"
                                    item-value="value" :value="revenueTypeFilter"
                                    @input="$emit('update:revenue-type-filter', $event)" label="Type"
                                    background-color="plusTextOnSecondary" dense outlined hide-details></v-select>

                            </v-col>
                            <!-- status -->
                            <v-col class="pb-0  d-lg-flex" cols="12" lg="2"
                                :class="displayFilters ? '' : 'd-lg-flex d-none'">
                                <v-select v-if="revenueStatusFilters" :items="revenueStatusFilters" item-text="text"
                                    item-value="value" :value="revenueStatusFilter"
                                    @input="$emit('update:revenue-status-filter', $event)" label="Status"
                                    background-color="plusTextOnSecondary" dense outlined hide-details></v-select>
                            </v-col>

                            <!-- label -->
                            <v-col class="pb-0  d-lg-flex" cols="12" lg="2"
                                :class="displayFilters ? '' : 'd-lg-flex d-none'">
                                <tags-select :value="subscriptionTagFilter"
                                    @input="$emit('update:subscription-tag-filter', $event)"
                                    @change="$emit('filter-revenue')" label="Filter by label"
                                    background-color="plusTextOnSecondary" :items="availableTags"></tags-select>
                            </v-col>

                            <!-- date filters -->
                            <v-col class="pb-0  d-lg-flex" cols="12" lg="2"
                                :class="displayFilters ? '' : 'd-lg-flex d-none'">
                                <DatePicker @change="$emit('get-recurrent-transactions', true)" :show-time="false"
                                    :value="fromFilter" @input="$emit('update:from-filter', $event)" :past-event="true">
                                </DatePicker>
                            </v-col>

                            <v-col class="pb-0  d-lg-flex" cols="12" lg="2"
                                :class="displayFilters ? '' : 'd-lg-flex d-none'">
                                <DatePicker @change="$emit('get-recurrent-transactions', true)" :show-time="false"
                                    :value="toFilter" @input="$emit('update:to-filter', $event)" :past-event="true">
                                </DatePicker>
                            </v-col>


                            <!-- <v-col class="pb-0" cols="12" sm="12" md="4">
                        <v-select clearable :label="$t('message.transactions_admin_plus.membership_type')" :hide-details="true" item-text="text"
                            item-value="value" outlined dense :items="membershipTypes"
                            v-model="membershipTypeFilter"></v-select>
                    </v-col> -->
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pa-0 d-lg-none d-flex justify-center">
                                <v-card-actions class="pr-0 mr-0">
                                    <v-btn @click="displayFilters = !displayFilters" text plain
                                        class="pa-0 ma-0 text-lowercase">
                                        <span
                                            class="font-roboto text-body-2 text-decoration-underline text-primary text-uppercase">
                                            {{
                                                !displayFilters ? $t('message.transactions_admin_plus.show_more_filters') :
                                                    $t('message.transactions_admin_plus.members_hide_filters') }}
                                        </span>
                                    </v-btn>
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-container>
            <!-- <v-container v-if="!loadingRevenue">
                <v-row v-allowed="'view_income'">
                    <v-col cols="12" sm="6">
                        <v-card elevation="0" outlined class="text-center">
                            <v-card-title class="text-subtitle-2 gray--text">{{ totalCountTitle }}</v-card-title>
                            <v-card-text class="text-h3">{{ revenueFiltered ? revenueFiltered.length : 0
                                }}</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-card v-bind="attrs" v-on="on" elevation="0" outlined class="text-center">
                                    <v-card-title class="text-subtitle-2 gray--text">
                                        {{ totalAmountTitle }}
                                        <v-icon class="ml-1" size="15"
                                            style="margin-top:-5px">mdi-information-outline</v-icon>
                                    </v-card-title>
                                    <v-card-text class="text-h3">{{ currencySymbol }}{{ totalRevenueAmount
                                        }}</v-card-text>
                                </v-card>
                            </template>
<span>{{ totalAmountTooltip }}</span>
</v-tooltip>
</v-col>
</v-row>
</v-container> -->
            <!-- <v-card-text class="mb-0 pb-0" v-if="!loadingRevenue">
                <v-row>
                    <v-col class="pb-0" cols="12" sm="12" md="6">
                        <v-text-field hide-details @keyup="$emit('filter-revenue')"
                            :label="$t('message.transactions_admin_plus.filter_by_member')" outlined dense :value="revenueUserFilter"
                            @input="$emit('update:revenue-user-filter', $event)"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete hide-details @change="$emit('filter-revenue')" outlined dense
                            :value="revenueProductFilter" @input="$emit('update:revenue-product-filter', $event)"
                            :items="allProducts" :label="$t('message.transactions_admin_plus.filter_by_product')" item-text="text"
                            item-value="value" clearable>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="mt-0"
                    v-if="(revenueTypeFilter === 'all' || revenueTypeFilter === 'subscriptions') && availableTags && availableTags.length > 0">
                    <v-col class="pb-0" cols="12" sm="12">
                        <tags-select :value="subscriptionTagFilter"
                            @input="$emit('update:subscription-tag-filter', $event)" @change="$emit('filter-revenue')"
                            :label="$t('message.transactions_admin_plus.filter_table_label')" :items="availableTags"></tags-select>
                    </v-col>
                </v-row>
                <v-row v-if="revenueTypeFilter === 'all' || revenueTypeFilter === 'subscriptions'">
                    <v-col cols="12" sm="12" md="5">
                        <div class="text-subtitle-2">{{ $t('message.transactions_admin_plus.from') }}:</div>
                        <DatePicker @change="$emit('get-recurrent-transactions', true)" :show-time="false"
                            :value="fromFilter" @input="$emit('update:from-filter', $event)" :past-event="true">
                        </DatePicker>
                    </v-col>
                    <v-col cols="12" sm="12" md="5">
                        <div class="text-subtitle-2">{{ $t('message.transactions_admin_plus.to') }}:</div>
                        <DatePicker @change="$emit('get-recurrent-transactions', true)" :show-time="false"
                            :value="toFilter" @input="$emit('update:to-filter', $event)" :past-event="true">
                        </DatePicker>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                        <v-btn small elevation="0" @click="$emit('get-recurrent-transactions')">{{ $t('message.transactions_admin_plus.clear')
                        }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-text> -->
            <div v-if="!loadingRevenue && revenueFiltered && revenueFiltered.length > 0">
                <v-card-actions class="mr-2">
                    <v-row>
                        <v-col cols="6" class="d-flex align-center">
                            <div class="font-roboto font-weight-medium" style="font-size: 1.25rem;">
                                Revenue ({{ revenueFiltered.length }}
                                )
                            </div>
                        </v-col>
                        <v-col cols="6" class="font-roboto d-flex justify-end">
                            <v-btn outlined :disabled="downloadingMembershipsTable"
                                :loading="downloadingMembershipsTable" text elevation="0" color="primary" class="" small
                                @click="$emit('download-memberships-table')">
                                <span>export CSV</span>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-btn
                        v-if="revenueProductFilter && (revenueTypeFilter === 'all' || revenueTypeFilter === 'onetime') && !productsResultByGraph"
                        outlined text elevation="0" color="primary" small
                        @click="$emit('toggle-products-result-by-graph')">
                        <v-icon class="mr-1">mdi-chart-line</v-icon>
                        <span>{{ $t('message.transactions_admin_plus.graph') }}</span>
                    </v-btn>
                    <v-btn v-else-if="revenueProductFilter && productsResultByGraph" outlined text elevation="0"
                        color="primary" small @click="$emit('toggle-products-result-by-graph')">
                        <v-icon class="mr-1">mdi-table</v-icon>
                        <span>{{ $t('message.transactions_admin_plus.table') }}</span>
                    </v-btn>
                </v-card-actions>
                <div
                    v-show="membershipsTrendlineToggle && (revenueTypeFilter === 'all' || revenueTypeFilter === 'subscriptions')">
                    <ApexChart type="area" :options="membershipsTrendline.options" height="350"
                        :series="membershipsTrendline.data">
                    </ApexChart>
                </div>

                <!-- Desktop table view -->
                <div v-if="!(revenueProductFilter && productsResultByGraph)" class="mt-2">

                    <v-data-table :loading="loadingMembershipsTable"
                        v-show="!membershipsTrendlineToggle || revenueTypeFilter === 'onetime'" item-key="revenueKey"
                        :headers="isSmallerDisplay() ? revenueHeadersMobile : revenueHeaders" :items="revenueFiltered"
                        :custom-sort="revenueSortMethod" class="tabble-revenue" :no-data-text="$t('message.transactions_admin_plus.no_data')"
                        :footer-props="{ itemsPerPageText: $t('message.transactions_admin_plus.rows_per_page'), itemsPerPageOptions: [25, 50, 75] }"
                        :hide-default-header="isSmallerDisplay()">


                        <!-- avatar -->
                        <template v-slot:item.avatar="{ item }">
                            <div class="d-flex align-center text-xs-center clickable pt-3 pb-3"
                                @click.stop="handleRowClick(item)" style="gap: 1.5rem;">
                                <v-avatar size="36"
                                    v-if="item.raw.buyer && (item.raw.buyer.userImageSmall || item.raw.buyer.userImage)">
                                    <v-img
                                        :src="item.raw.buyer && item.raw.buyer.userImageSmall ? item.raw.buyer.userImageSmall : item.raw.buyer.userImage"></v-img>
                                </v-avatar>
                                <v-avatar size="36" color="plusIndigoLighten3" v-else>
                                    <span class="font-roboto white--text text-subtitle-1">{{
                                        getInitials(getDisplayBuyer(item))
                                        }}</span>
                                </v-avatar>
                            </div>
                        </template>


                        <!-- mobile view  -->
                        <!-- { text: "", value: "avatar", sortable: true },
                { text: "Name", value: "buyerMobile" },
                { text: "Status", value: "statusMobile", align: "center" }, -->


                        <!-- name -->
                        <template v-slot:item.buyerMobile="{ item }">
                            <div class="d-flex flex-column justify-center text-xs-center clickable pt-3 pb-3"
                                @click.stop="handleRowClick(item)">

                                <span class="clickable font-roboto text-subtitle-1 font-weight-semibold"
                                    @click.stop="handleRowClick(item)">
                                    {{ getDisplayBuyer(item) }}
                                </span>

                                <span class="clickable font-roboto text-subtitle-2 font-weight-regular"
                                    @click.stop="handleRowClick(item)">

                                    {{ truncate(getDisplayProduct(item), 30, false) }}
                                </span>

                            </div>
                        </template>

                        <!-- status -->
                        <template v-slot:item.statusMobile="{ item }">
                            <div class="d-flex flex-column justify-center text-xs-center clickable pt-3 pb-3">
                                <span class="font-roboto text-subtitle-1 font-weight-semibold">
                                    {{ currencySymbol }}{{ getAmountForItemProp(item) }}
                                </span>
                                <div>
                                    <v-chip :color="getStatusColorForItem(item).background" small
                                        :style="{ color: getStatusColorForItem(item).color }">
                                        {{ getStatusTextForItem(item) }}
                                    </v-chip>
                                </div>
                            </div>
                        </template>

                        <!-- desktop view -->
                        <!-- name -->
                        <template v-slot:item.buyer="{ item }">
                            <div class="d-flex align-center text-xs-center clickable pt-3 pb-3"
                                @click.stop="handleRowClick(item)" style="gap: 1.5rem;">
                                <span class="clickable font-roboto text-subtitle-2 font-weight-regular"
                                    @click.stop="handleRowClick(item)">
                                    {{ getDisplayBuyer(item) }}
                                </span>

                            </div>
                        </template>


                        <!-- subscription plan -->
                        <template v-slot:item.product="{ item }">
                            <span class="clickable font-roboto text-subtitle-2 font-weight-regular"
                                @click.stop="handleRowClick(item)">
                                <v-tooltip top v-if="item.type === 'subscription' && item.raw.hasNotes">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" size="15"
                                            color="accent">mdi-message-text-outline</v-icon>
                                    </template>
                                    <span>{{ $t('message.transactions_admin_plus.has_notes') }}</span>
                                </v-tooltip>
                                {{ truncate(getDisplayProduct(item), 30, false) }}
                            </span>
                        </template>


                        <!-- frequency -->
                        <template v-slot:item.frequency="{ item }">
                            <span v-if="item.type === 'subscription'"
                                class="font-roboto text-subtitle-2 font-weight-regular">
                                <span v-if="item.raw.productInterval == 'month'">{{
                                    $t('message.transactions_admin_plus.interval_month').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'day'">{{
                                    $t('message.transactions_admin_plus.interval_day').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'week'">{{
                                    $t('message.transactions_admin_plus.interval_week').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'bi-week'">{{
                                    $t('message.transactions_admin_plus.interval_bi-week').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'bi-year'">{{
                                    $t('message.transactions_admin_plus.interval_bi-year').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'year'">{{
                                    $t('message.transactions_admin_plus.interval_year').toLowerCase() }}</span>
                                <span v-else-if="item.raw.productInterval == 'once'">{{ $t('message.transactions_admin_plus.once').toLowerCase()
                                }}</span>
                                <span v-else-if="item.raw.expiringSoon">{{ $t('message.transactions_admin_plus.expiring_soon').toLowerCase()
                                }}</span>
                                <span v-else>{{ $t('message.transactions_admin_plus.manual').toLowerCase() }}</span>
                            </span>

                        </template>

                        <!-- sale date -->
                        <template v-slot:item.date="{ item }">
                            <span class="font-roboto text-subtitle-2 font-weight-regular">
                                {{ $d(new Date(item.raw.time), 'month_day_year', $i18n.locale) }}
                            </span>
                        </template>


                        <!-- billingDay -->
                        <template v-slot:item.billingDay="{ item }">
                            <span v-if="item.type === 'subscription'"
                                class="font-roboto text-subtitle-2 font-weight-regular">
                                {{ new Date(item.raw.billingDate).getDate() }}
                            </span>
                        </template>

                        <!-- price -->
                        <template v-slot:item.price="{ item }">
                            <span class="font-roboto text-subtitle-2 font-weight-regular">
                                {{ currencySymbol }}{{ getAmountForItemProp(item) }}
                            </span>
                        </template>

                        <!-- status -->
                        <template v-slot:item.status="{ item }">
                            <v-chip :color="getStatusColorForItem(item).background" small
                                :style="{ color: getStatusColorForItem(item).color }">
                                {{ getStatusTextForItem(item) }}
                            </v-chip>
                        </template>


                    </v-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import TagsSelect from "@/components/inputs/TagsSelect.vue";
import ApexChart from 'vue-apexcharts';

export default {
    name: "ViewRevenue",
    components: { DatePicker, TagsSelect, ApexChart },
    props: {
        academy: { type: Object, default: null },
        loadingRevenue: { type: Boolean, default: false },
        stripeReady: { type: Boolean, default: false },
        revenueFiltered: { type: Array, default: () => [] },
        revenueTypeFilter: { type: String, default: 'all' },
        revenueStatusFilter: { type: String, default: 'all' },
        subscriptionsFilter: { default: null },
        pendingFilter: { type: Boolean, default: false },
        revenueUserFilter: { default: null },
        revenueProductFilter: { default: null },
        subscriptionTagFilter: { default: null },
        allProducts: { type: Array, default: () => [] },
        availableTags: { type: Array, default: () => [] },
        monthlyRecurringRevenueAmount: { type: [Number, String], default: 0 },
        monthlyTotalRevenue: { type: [Number, String], default: 0 },
        monthlyRecurringRevenue: { type: [Number, String], default: 0 },
        oneTimeRevenueAmount: { type: [Number, String], default: 0 },
        oneTimeRevenueCount: { type: Number, default: 0 },
        pendingPaymentsAmount: { type: [Number, String], default: 0 },
        pendingPaymentsCount: { type: Number, default: 0 },
        fromFilter: { default: null },
        toFilter: { default: null },
        totalCountTitle: { type: String, default: '' },
        totalAmountTitle: { type: String, default: '' },
        totalRevenueAmount: { type: [Number, String], default: 0 },
        totalAmountTooltip: { type: String, default: '' },
        currencySymbol: { type: String, default: '$' },
        productsResultByGraph: { type: Boolean, default: false },
        loadingProductTimeline: { type: Boolean, default: false },
        productTimelineGraph: { default: null },
        downloadingMembershipsTable: { type: Boolean, default: false },
        membershipsTrendline: { type: Object, default: () => ({ ready: false }) },
        membershipsTrendlineToggle: { type: Boolean, default: false },
        loadingMembershipsTable: { type: Boolean, default: false },
        cancelledFiltered: { type: Array, default: () => [] },
        loadingCancelledSubscriptions: { type: Boolean, default: false },
        revenueHeaders: { type: Array, default: () => [] },
        revenueHeadersMobile: { type: Array, default: () => [] },
        getStatusTextForItem: { type: Function, required: true },
        getAmountForItem: { type: Function, required: true }
    },
    data() {
        return {
            revenueTypeFilters: [
                { text: this.$t('message.transactions_admin_plus.all'), value: 'all' },
                { text: this.$t('message.transactions_admin_plus.memberships'), value: 'subscriptions' },
                { text: this.$t('message.transactions_admin_plus.one_time_purchases'), value: 'onetime' }
            ],
            revenueStatusFilters: [
                { text: this.$t('message.transactions_admin_plus.all'), value: 'all' },
                { text: this.$t('message.transactions_admin_plus.paid'), value: 'paid' },
                { text: this.$t('message.transactions_admin_plus.pending'), value: 'pending' },
                { text: this.$t('message.transactions_admin_plus.refunded'), value: 'refunded' },
                { text: this.$t('message.transactions_admin_plus.active'), value: 'active' },
                { text: this.$t('message.transactions_admin_plus.expired'), value: 'expired' }
            ],
            displayFilters: false
        };
    },
    emits: [
        'filter-revenue', 'get-recurrent-transactions', 'download-memberships-table', 'toggle-memberships-trendline',
        'toggle-products-result-by-graph', 'get-product-timeline', 'navigate-to-transaction', 'go-to-transaction',
        'go-to-member', 'get-cancelled-subcriptions',
        'update:revenue-type-filter', 'update:revenue-status-filter', 'update:subscriptions-filter', 'update:pending-filter',
        'update:revenue-user-filter', 'update:revenue-product-filter', 'update:subscription-tag-filter',
        'update:from-filter', 'update:to-filter'
    ],
    methods: {
        getStatusColorForItem(item) {
            const transactionStatusColors = {
                active: { color: "#4CAF50", background: "#E8F5E9" }, // success
                completed: { color: "#4CAF50", background: "#E8F5E9" }, // success
                succeeded: { color: "#4CAF50", background: "#E8F5E9" }, // success
                success: { color: "#4CAF50", background: "#E8F5E9" }, // success
                pending_payment: { color: "#B71C1C", background: "#FFEBEE" }, // error
                expired: { color: "#B71C1C", background: "#FFEBEE" }, // error
                paused: { color: "#FF6F00", background: "#FFF8E1" }, // yellow
                trialing: { color: "#FF6F00", background: "#FFF8E1" }, // yellow
                open: { color: "#B71C1C", background: "#FFEBEE" }, // error
                past_due: { color: "#B71C1C", background: "#FFEBEE" }, // error
                pauseDate: { color: "#FF6F00", background: "#FFF8E1" }, // yellow (usando FF6F00)
                cancellationDate: { color: "#B71C1C", background: "#FFEBEE" }, // error
                default: { color: "#B71C1C", background: "#FFEBEE" } // error
            };
            const status = this.getStatusTextForItem(item).toLowerCase();
            return transactionStatusColors[status] || transactionStatusColors['default'];
        },
        toggleDisplayFilters() {
            this.displayFilters = !this.displayFilters;
        },
        getDisplayBuyer(item) {
            if (item.raw.buyer) return item.raw.buyer.displayName;
            if (item.raw.email) return item.raw.email;
            return this.$t('message.transactions_admin_plus.pending_onboarding');
        },
        getDisplayProduct(item) {
            if (item.type === 'subscription') {
                return item.raw.productName || (item.raw.product && item.raw.product.name) || '';
            }
            const r = item.raw;
            if (r.product) return (r.product.name || '') + (r.product.size ? ' (' + r.product.size + ')' : '');
            if (r.items && r.items[0]) {
                if (r.items.length === 1 && r.items[0].product) return r.items[0].product.name + (r.items[0].product.size ? ' (' + r.items[0].product.size + ')' : '');
                if (r.items.length === 1 && r.items[0].name) return r.items[0].name + (r.items[0].size ? ' (' + r.items[0].size + ')' : '');
                return r.items.length + ' ' + this.$t('message.transactions_admin_plus.items');
            }
            return '';
        },
        getAmountForItemProp(item) {
            return this.getAmountForItem(item);
        },
        getStatusBadgeContent(item) {
            if (item.type !== 'onetime') return '';
            const r = item.raw;
            if (r.completed) return '✓';
            if (r.expired) return '⚠';
            if (r.cancelled) return 'x';
            return '∙∙∙';
        },
        handleRowClick(item) {
            this.$emit('navigate-to-revenue-item', item);
        },
        userImg(src) {
            return this.$emit('user-img', src);
        },
        assets(path) {
            return this.$emit('assets', path);
        },
        revenueSortMethod(items, index, isDesc) {
            if (!items || !index || index.length === 0) return items;
            const idx = index[0];
            const desc = isDesc && isDesc[0];
            const cmp = (a, b) => {
                let aVal, bVal;
                if (idx === 'time') {
                    aVal = new Date(a.raw.time || 0).getTime();
                    bVal = new Date(b.raw.time || 0).getTime();
                    return desc ? bVal - aVal : aVal - bVal;
                }
                if (idx === 'amount') {
                    aVal = parseFloat(this.getAmountForItem(a)) || 0;
                    bVal = parseFloat(this.getAmountForItem(b)) || 0;
                    return desc ? bVal - aVal : aVal - bVal;
                }
                if (idx === 'buyer') {
                    aVal = (this.getDisplayBuyer(a) || '').toLowerCase();
                    bVal = (this.getDisplayBuyer(b) || '').toLowerCase();
                    return desc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
                }
                if (idx === 'product') {
                    aVal = (this.getDisplayProduct(a) || '').toLowerCase();
                    bVal = (this.getDisplayProduct(b) || '').toLowerCase();
                    return desc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
                }
                if (idx === 'status') {
                    aVal = (this.getStatusTextForItem(a) || '').toLowerCase();
                    bVal = (this.getStatusTextForItem(b) || '').toLowerCase();
                    return desc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
                }
                if (idx === 'type') {
                    aVal = a.type === 'subscription' ? 0 : 1;
                    bVal = b.type === 'subscription' ? 0 : 1;
                    return desc ? bVal - aVal : aVal - bVal;
                }
                return 0;
            };
            return [...items].sort(cmp);
        }
    }
};
</script>

<style>
.border-filter-revenue {
    border: 1px solid #E0E0E0 !important;
    background-color: #FAFAFA !important;
}

.date-picker {
    font-size: large !important;
    border: 1px solid var(--black-042, rgba(0, 0, 0, 0.42));
    border-radius: 4px;
    display: block;
    width: 100%;
    padding: 0.50rem;
    margin: 0px;
    background-color: #fff;

}

.tabble-revenue .v-data-table-header th,
.tabble-revenue .v-data-table td {
    font-family: "Roboto", sans-serif !important;
    font-weight: bold !important;
    font-size: 12px !important;
}


@media (max-width: 1264px) {
    .tabble-revenue {
        border: 1px solid #EEE;
        padding: 1rem !important;
    }
}

.tabble-revenue .v-data-table__mobile-row__cell {
    text-align: left !important;
}
</style>
